// Leadership level mappings
export const leadershipLabels = {
  admin: 'Ultimate Leader',
  team: 'Team Lead',
  group: 'Group Lead',
  subgroup: 'Subgroup Lead',
  null: 'Member',
  undefined: 'Member'
}

// Role mappings (everyone is either org_admin or member)
export const roleLabels = {
  org_admin: 'Ultimate Leader',
  member: 'Member',
  unassigned: 'New Member'
}

// Group type mappings
export const groupLabels = {
  faculty: 'Team',
  department: 'Group',
  level: 'Subgroup'
}

// Table column labels
export const tableLabels = {
  name: 'Full Name',
  email: 'Email Address',
  role: 'Role',
  status: 'Status',
  joined: 'Joined'
}

// Get display label for a user (simplified - just show their role/leadership)
export const getUserDisplayLabel = (user) => {
  if (!user) return 'Unknown'
  
  if (user.role === 'org_admin') {
    return 'Ultimate Leader'
  }
  
  if (user.role === 'unassigned') {
    return 'New Member'
  }
  
  // Everyone else is a member, show their leadership level
  if (user.leadership_level === 'team') {
    return 'Team Lead'
  }
  
  if (user.leadership_level === 'group') {
    return 'Group Lead'
  }
  
  if (user.leadership_level === 'subgroup') {
    return 'Subgroup Lead'
  }
  
  return 'Member'
}

// Get role label (legacy support)
export const getRoleLabel = (role) => {
  return roleLabels[role] || role
}

// Get leadership label
export const getLeadershipLabel = (level) => {
  return leadershipLabels[level] || 'Member'
}

// Get group label
export const getGroupLabel = (type) => {
  return groupLabels[type] || type
}

// Get filter display name
export const getFilterLabel = (filterType) => {
  const labels = {
    all: 'All',
    org_admin: 'Leaders',
    team: 'Team Leads',
    group: 'Group Leads',
    subgroup: 'Subgroup Leads',
    member: 'Members',
    unassigned: 'New Members'
  }
  return labels[filterType] || filterType
}